class AnnouncementSliderComponent extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();
    this.positionArrows();
    $(this.slider).on('init afterChange', () => this.positionArrows());
    window.addEventListener('resize', () => this.positionArrows());
  }

  positionArrows() {
    const activeSlide = this.querySelector('.slick-current span');

    if (!activeSlide) return;

    const prevArrow = this.querySelector('.slick-prev');
    const nextArrow = this.querySelector('.slick-next');

    if (!prevArrow || !nextArrow) return;

    const rect = activeSlide.getBoundingClientRect();
    const wrapperRect = this.slider.getBoundingClientRect();

    const offsetLeft = rect.left - wrapperRect.left;
    const slideWidth = rect.width;

    // Adjust arrow positions
    prevArrow.style.position = 'absolute';
    prevArrow.style.left = `${offsetLeft - 20}px`; // tweak -20 as needed
    prevArrow.style.opacity = '1'; // Ensure visibility

    nextArrow.style.position = 'absolute';
    nextArrow.style.left = `${offsetLeft + slideWidth + 10}px`; // tweak +10 as needed
    nextArrow.style.opacity = '1'; // Ensure visibility
  }
}
customElements.define('announcement-slider-component', AnnouncementSliderComponent);
